import clsx from 'clsx';
import Pill, {isValidPillColor} from 'components/Pill';
import TooltipWrapper from 'components/Tooltip';
import {FC} from 'react';

export type TagsValueProps = {
    className?: string;
    value: string[] | Value[];
};
type Value = {
    color?: string;
    label: string;
    tooltip?: string;
};

const TagsValue: FC<TagsValueProps> = ({className, value}) => (
    <div className={clsx('flex flex-wrap gap-2', className)}>
        {value.map((data) => {
            if (typeof data === 'string') {
                return (
                    <Pill
                        color="grey"
                        isTruncated={false}
                        key={data}
                        label={data}
                    />
                );
            } else {
                const {color, label, tooltip} = data;
                const content = (
                    <Pill
                        color={isValidPillColor(color) ? color : 'grey'}
                        isTruncated={false}
                        key={label}
                        label={label}
                    />
                );

                if (tooltip) {
                    return (
                        <TooltipWrapper key={label} message={tooltip}>
                            {content}
                        </TooltipWrapper>
                    );
                } else {
                    return content;
                }
            }
        })}
    </div>
);

export default TagsValue;
